import { createCRUDHook } from './createCRUDHook';
import { WidthSettingsDto } from 'utils/models';
import { GET_WIDTH_DATA_BY_WIDTH, TLKP_WIDTH_SETTING } from './apiEndPoints';
interface WidthSettingsCustomOperations {
  getWidthSettingsDataByWidth: (length: number) => Promise<WidthSettingsDto>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  WidthSettingsDto,
  WidthSettingsDto[],
  WidthSettingsCustomOperations
>({
  entityName: 'WidthSettings',
  endpoint: TLKP_WIDTH_SETTING,
  customOperations: (auth) => ({
    getWidthSettingsDataByWidth: async (
      width: number
    ): Promise<WidthSettingsDto> => {
      try {
        let res = await auth.makeAuthenticatedGet(
          TLKP_WIDTH_SETTING + GET_WIDTH_DATA_BY_WIDTH + `?width=${width}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const WidthSettingsContext = Context;
export const useWidthSettingsManager = useManager;
export const useWidthSettings = useConsumer;
